/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React from "react";
import AllReports from "../../../MiddleMileOperations/ExceptionReports/allReports";
const HubOpsDashboard = () => {
    const embeddedId = "6d272eb4-739c-42e0-ace4-ac4c8c28946b";
    const rsl = [];
    const title = "Hub Ops Dashboard";
    return (
        <div>
            <AllReports embeddedId={embeddedId} rsl={rsl} title={title} />
        </div>
    );
};

export default HubOpsDashboard;
